import {
  TEMPLATE_CARD_BACKGROUND_KEY,
  findTextIdForCardBackground,
  getGroupMemberIds,
  getTextBackgroundCardTextId,
  isTextBackgroundCardGroup,
} from './annotationGroupUtils';
import { WATERMARK_ANNOTATION_ID } from './constants';
import { normalizeSelectionRect, rectsIntersect } from './normalizeSelectionRect';

const resolveMarqueeSelectionIds = (annotations, annotationId) => {
  const annotation = annotations[annotationId];
  if (!annotation || annotation.visible === false) {
    return [];
  }
  if (annotationId === WATERMARK_ANNOTATION_ID) {
    return [];
  }

  if (annotation[TEMPLATE_CARD_BACKGROUND_KEY]) {
    const textId =
      (annotation.groupId &&
        isTextBackgroundCardGroup(annotations, annotation.groupId) &&
        getTextBackgroundCardTextId(annotations, annotation.groupId)) ||
      findTextIdForCardBackground(annotations, annotationId);
    return textId ? [textId] : [];
  }

  if (
    annotation.groupId &&
    isTextBackgroundCardGroup(annotations, annotation.groupId)
  ) {
    const textId = getTextBackgroundCardTextId(annotations, annotation.groupId);
    return textId ? [textId] : [annotationId];
  }

  if (annotation.groupId) {
    return getGroupMemberIds(annotations, annotationId);
  }

  return [annotationId];
};

export const getAnnotationIdsInMarqueeRect = (
  designLayer,
  annotations = {},
  selectionRect,
) => {
  if (!designLayer?.findOne || !selectionRect) {
    return [];
  }

  const stage = designLayer.getStage?.();
  if (!stage) {
    return [];
  }

  const normalized = normalizeSelectionRect(selectionRect);
  if (normalized.width < 1 && normalized.height < 1) {
    return [];
  }

  const selectedIds = new Set();

  Object.values(annotations).forEach((annotation) => {
    if (!annotation?.id || annotation.visible === false) {
      return;
    }
    if (annotation.id === WATERMARK_ANNOTATION_ID) {
      return;
    }

    const node = designLayer.findOne(`#${annotation.id}`);
    if (!node) {
      return;
    }

    const bounds = node.getClientRect({ relativeTo: stage });
    if (!rectsIntersect(normalized, bounds)) {
      return;
    }

    resolveMarqueeSelectionIds(annotations, annotation.id).forEach((id) => {
      if (annotations[id]) {
        selectedIds.add(id);
      }
    });
  });

  return Array.from(selectedIds);
};

export default getAnnotationIdsInMarqueeRect;
